//
//
// 存放变量

let urlencode = require('urlencode');
const sppSecret = 'f64327b0c9570748dcf0798ef25ffeee';//公众号密钥，前端不需要使用，仅作保存
let appId,redirectUrl;
if(process.env.NODE_ENV === 'development') {
  appId = 'wx75628741530295a9';
  redirectUrl = urlencode('http://172.30.18.197:8080/home')
}else{
  appId = 'wx491440843c14d31a';
  redirectUrl = urlencode('http://wdsxapi.ovopark.com/home')
}
export {appId, redirectUrl}

//订单状态
export const orderStatus = {
  1: '待付款',
  // 2: '未发货', //后台的问题，2，3都为未发货
  3: '未发货',
  4: '待收货',
  5: '已完成',
  // 6: '未评价', //已完成就是未评价
  7: '已评价',
  8: '退款申请中',
  9: '退款申请审核不通过',
  10: '退款申请审核通过未到账',
  11: '退款申请完成退款已到账',
  12: '换货申请中',
  13: '换货申请已发货',
  14: '换货申请商家已收货',
  15: '换货申请商家拒绝',
  16: '换货申请商家通过',
  17: '换货申请商家通过并寄出',
  18: '换货申请用户已收到新商品',
  19: '已取消',
  20: '已删除',
  21: '已关闭',
};

export const serviceReason = [
  {name: '发错货'},
  {name: '商品损坏'},
  {name: '商品与页面描述不符'},
  {name: '缺少件'},
  {name: '质量问题'},
  {name: '其他'},
]